export enum PrinterPlatform {
  P55 = 1,
  P95 = 2,
  P55S = 3,
  P95S = 4,
  P55SCrown = 5,
  P95SCrown = 6,
  P55SArch = 7,
  P95SArch = 8,
  P23P = 9,
  MDS = 10,
  P23PArch = 11,
}

export enum SPRMetadataPrinterPlatform {
  P55 = 'pro55',
  P95 = 'pro95',
  P55S = 'pros55',
  P95S = 'pros95',
  P23P = 'pro2',
  MDS = 'midas',
}

export enum SPRExportMetadataPrinterPlatform {
  P55 = 'pro55',
  P95 = 'pro95',
  P55S = 'PS5P',
  P95S = 'PS9P',
  P23P = 'pro2',
}

export enum PrinterPrefixes {
  SprintRayPro95Prefix = 'P95',
  SprintRayPro55Prefix = 'P55',
  SprintRayPro95SPrefix = 'PS9',
  SprintRayPro55SPrefix = 'PS5',
  SprintRayPro2Prefix = 'P23P',
  SprintRayMidasPrefix = 'MR4P',
}

export enum PlatformViewType {
  PrintPlate = 1,
  GridPlatform = 2,
}

export enum MidasGroup {
  Square = 1,
  Triangle = 2,
  Circle = 3,
}
